import { render, staticRenderFns } from "./IndexRatingStars.vue?vue&type=template&id=4fdcc5f2"
import script from "./IndexRatingStars.vue?vue&type=script&lang=js"
export * from "./IndexRatingStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports